import React from "react";

const PRIMARY = "#1d4ed8";
const NAVY = "#0f1c3f";
const LIGHT = "#e8f0fe";

// Shown once each time a member/coach opens the "View Availability" step for
// a facility (see openFacilityAvailability() in MemberDashboard.jsx /
// CoachDashboard.jsx) — a heads-up that createBooking() locks every entry's
// slots for a 10-minute window (see bookingService.js), before they've
// picked any slots yet. "Continue to Booking" just closes this; nothing is
// locked or booked by this modal itself.
export default function BookingTimeLimitModal({ onContinue }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm" role="dialog" aria-modal="true">
      <div className="relative w-full max-w-sm bg-white rounded-2xl shadow-2xl p-6 text-center">
        <div className="mx-auto w-14 h-14 rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: LIGHT }}>
          <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke={PRIMARY}>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M12 8v4l2.5 2.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h2 className="text-lg font-bold" style={{ color: NAVY }}>Complete Your Booking Within 10 Minutes</h2>
        <p className="text-sm text-gray-500 mt-2 leading-relaxed">
          Once you start the booking process, you have <span className="font-semibold text-gray-700">10 minutes</span> to complete your booking and payment. If you do not complete it within this time, your selected slot will be released and you may need to start the booking again.
        </p>
        <div className="flex flex-col gap-2.5 mt-6">
          <button
            type="button"
            onClick={onContinue}
            className="w-full px-5 py-2.5 rounded-xl text-sm font-semibold text-white transition shadow-md hover:shadow-lg"
            style={{ backgroundColor: PRIMARY, boxShadow: `0 4px 12px ${PRIMARY}4d` }}
          >
            Continue to Booking
          </button>
        </div>
      </div>
    </div>
  );
}
